import React from 'react'
import Wrapper from '../../components/layout/Wrapper'
import styled from 'styled-components'
import breakpoint from 'styled-components-breakpoint'
import imgCallCenter from '../../images/landing-contact-callcenter.svg'
import imgEmail from '../../images/asset-12.svg'
import imgSucursales from '../../images/landing-contact-locations.svg'

const Container = styled(Wrapper)`
`

const ItemsGrid = styled.div`
  display: flex;
  flex-flow: column nowrap;
  margin-bottom: 40px;

  & > div {
    flex: 1 0 30%;
    margin-bottom: 20px;
    display: flex;
  }

  ${breakpoint('tablet')`
    flex-flow: row wrap;
    justify-content: space-between;
  `}
`

const ItemContainer = styled.div`
  display: flex;

  h4 {
    margin-top: 0;
    margin-bottom: 15px;
  }

  p {
    font-size: 12px;
    margin-right: 50px;
  }

  & > div {
    flex: 1 0;
  }

  & > div:first-of-type {
    flex: 0 0 60px;

    ${breakpoint('tablet')`
      margin-right: 20px;
      flex: 0 0 80px;
    `}
  }
`

const Disclaimer = styled.div`
  background: #f1f1f1;
  margin: 20px 0 0;
  padding: 20px 0 40px;

  h4 {
    font-size: 17px;
    margin-top: 19px;
  }
  p {
    font-size: 11px;
  }
`

const Item = ({ title, image, children }) => {
  return (
    <ItemContainer>
      <div>
        <img src={image} alt={title} />
      </div>
      <div>
        <h4>{title}</h4>
        <p>{children}</p>
      </div>
    </ItemContainer>
  )
}

export default ({ footer, countryAbr }) => {

  return (
    <div>
      <Container>
        <ItemsGrid>
          <Item title="Call Center" image={imgCallCenter}>
            Consultas sobre tu cuenta <a href="tel:22959797">2295-9797</a>
          </Item>

          <Item title="WebChat" image={imgEmail}>
            Consultas sobre tu solicitud de cuenta de ahorros <a href="https://www.baccredomatic.com/es-cr">click aquí</a>
          </Item>

          <Item title="Sucursales" image={imgSucursales}>
            <a
              href={`https://www.bacubicanos.com/responsive/index.aspx?pCountry=${countryAbr}&pChannel=BACNET`}
            >
              {
                // TODO replace this with a helper method
              }
              {['CRI', 'NIC'].includes(countryAbr) ? 'Hacé' : 'Haz'} clic aquí
            </a>{' '}
            para ver nuestros puntos de servicio.
          </Item>
        </ItemsGrid>
      </Container>
      <Disclaimer>
        <Container>
          <h4><strong>Para ver el reglamento </strong><a href="https://www.baccredomatic.com/sites/default/files/reglamento-ahorrar-es-mas-facil-de-lo-que-pensasv2.pdf ">hacé click aquí</a></h4>
        </Container>
      </Disclaimer>
    </div>
  )
}
